/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: version,バージョン
 * note:
 *  - Webappのバージョンをチェックし、更新が必要（S3に新しいバージョンがアップされている）かを調べる
 * sample:
 *  - src/boot/zettant-init.ts
 * :ZNOTE:
 */

import {getStorageValue, updateStorageValue} from '@zettant/storageUtils';
import {getAppParams} from '@zettant/commonUtils';

const params: any = getAppParams();
const appVersion = params.version;
let newAppVersionFlag = false;

const verTag = `verOf${params.projectName}-${params.env}`;
const oldVersion = getStorageValue(verTag);
if (!oldVersion || oldVersion.version !== appVersion) {
  newAppVersionFlag = true;
  updateStorageValue(verTag, {version: appVersion});  // このアプリバージョンを登録する
}

const getAppVersion = () => appVersion;
const isNewAppVersion = () => newAppVersionFlag;

export {getAppVersion, isNewAppVersion};
